import { call, put } from 'redux-saga/effects';
import UpdateUserNotificationSettingsActions from '../redux/UpdateUserNotificationSettingsRedux';
import GetMeActions from '../redux/GetMeRedux';
import { api } from './api';

export function* updateUserNotificationSettingsSagas(action: any): Generator<any, void, any> {
  const { notificationType, status } = action;
  console.log('UpdateUserNotificationSettingsSaga: Updating notification setting:', { notificationType, status });
  
  const response = yield call(api.updateUserNotificationSettings, notificationType, status);

  // success?
  if (response.ok) {
    console.log('UpdateUserNotificationSettingsSaga: API call successful, updating Redux state');
    
    // Update the notification settings state
    yield put(UpdateUserNotificationSettingsActions.updateUserNotificationSettingsSuccess(response.data));
    
    // Also update the getMe state to persist the notification change
    // This ensures the notification settings persist after page refresh
    console.log('UpdateUserNotificationSettingsSaga: Refreshing user data to update notification settings');
    const currentUserResponse = yield call(api.getMe);
    if (currentUserResponse.ok) {
      const { status: userStatus, locale, settings } = currentUserResponse.data;
      console.log('UpdateUserNotificationSettingsSaga: Got updated user data, updating getMe state');
      yield put(GetMeActions.getMeSuccess(userStatus, locale, settings));
    } else {
      console.warn('UpdateUserNotificationSettingsSaga: Failed to get updated user data');
    }
  } else {
    console.error('UpdateUserNotificationSettingsSaga: API call failed');
    yield put(UpdateUserNotificationSettingsActions.updateUserNotificationSettingsFailure());
  }
}